import { getIdFromPath } from "lqx-react";
import * as React from 'react';
import { LinkPolicyToInvoices } from "./link-policy-to-invoices";

export const LinkPolicyPageRouter = () => {
    const policyId = getIdFromPath(3);

    return policyId !== undefined ?
        <LinkPolicyToInvoices policyId={ policyId } /> :
        (
            <span>No policy was selected</span>
        );
};